export class ClickContext {

    private isSingleClick = true;

    clickHandler(handler: ClickHandler): ClickHandler {
        return function() {
            const args = arguments;
            this.isSingleClick = true;
            setTimeout(() => {
                this.isSingleClick && handler.apply(undefined, args);
            }, 250);
        }
    }

    dblClickHandler(handler: ClickHandler): ClickHandler {
        return function() {
            const args = arguments;
            this.isSingleClick = false;
            setTimeout(() => {
                this.isSingleClick = true;
            }, 250);
            handler.apply(undefined, args);
        }
    }
}

type ClickHandler = (...any) => void;